module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.invoice).length) ? _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('modal-log', {
    attrs: {
      "id": _vm.invoice.identifier
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-float-right"
  }, [_c('div', {
    staticClass: "col-md-12 col-xlg-12 col-lg-12"
  }, [_c('div', {
    staticClass: "ls-float-right"
  }, [_c('dropdown', {
    staticClass: "ls-dropdown ls-lg-margin-right",
    attrs: {
      "id": "dropdown-nf",
      "data-ls-module": "dropdown"
    }
  }, [_c('a', {
    staticClass: "ls-btn-primary ls-no-margin ls-xs-margin-right ls-xs-margin-top",
    attrs: {
      "href": "javascript:void(0)"
    },
    slot: "trigger"
  }, [_vm._v("Nota Fiscal")]), _vm._v(" "), _c('nav', {
    staticClass: "ls-dropdown-nav",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "list"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "nfs"
    }
  }, [(!_vm.taxInvoiceExists() || _vm.isCanceled()) ? _c('a', {
    attrs: {
      "role": "option",
      "aria-expanded": "false",
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.generateTaxInvoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.generate_tax_invoice')))]) : _vm._e()]), _vm._v(" "), (_vm.taxInvoiceExists()) ? _c('a', {
    attrs: {
      "role": "option",
      "aria-expanded": "false",
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.openTaxInvoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.open_tax_invoice')))]) : _vm._e(), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "nfs"
    }
  }, [(_vm.taxInvoiceExists() && !_vm.isCanceled()) ? _c('a', {
    staticClass: "ls-color-danger",
    attrs: {
      "role": "option",
      "aria-expanded": "false",
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showModalCancelTaxInvoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.cancel_tax_invoice')))]) : _vm._e()])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "ls-float-right"
  }, [(_vm.showPaymentButtom()) ? _c('dropdown', {
    staticClass: "ls-dropdown",
    attrs: {
      "data-ls-module": "dropdown",
      "id": "dropdown-payment"
    }
  }, [_c('a', {
    staticClass: "ls-btn-primary ls-no-margin ls-xs-margin-right ls-xs-margin-top",
    attrs: {
      "href": "javascript:void(0)"
    },
    slot: "trigger"
  }, [_vm._v("Pagamento")]), _vm._v(" "), _c('nav', {
    staticClass: "ls-dropdown-nav",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "list"
  }, [(_vm.invoice.status === 'awaiting_payment') ? _c('a', {
    attrs: {
      "target": "_blank",
      "title": "Acessar",
      "href": _vm.invoice.payment_url
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.payment_link')))]) : _vm._e(), _vm._v(" "), (_vm.invoice.status === 'awaiting_payment') ? _c('a', {
    attrs: {
      "target": "_blank",
      "title": "Emitir",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getBillet()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.emit_billet')))]) : _vm._e(), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "confirm_invoice"
    }
  }, [(_vm.invoice.status === 'awaiting_payment') ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showInvoiceConfirmationModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.set_paid')))]) : _vm._e()]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "update_due_date_invoice ls-xs-margin-top"
    }
  }, [(_vm.invoice.status === 'awaiting_payment') ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showModalChangeCorpDueDate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.change_due_date')))]) : _vm._e()]), _vm._v(" "), (_vm.invoice.status === 'awaiting_payment') ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setResendPaymentData()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.send_payment_url')))]) : _vm._e(), _vm._v(" "), (_vm.invoice.status === 'awaiting_payment') ? _c('a', {
    attrs: {
      "target": "_blank",
      "title": "Acessar",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModalCancelation()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _vm._v(" "), (_vm.invoice.status === 'paid') ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModalReverse()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.buttons.reverse_invoice')))]) : _vm._e()], 1)]) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12 ls-sm-margin-top ls-display-flex flex-wrap-wrap"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12 lg-md-margin-bottom-in-sm ls-xs-margin-top-in-sm"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space ls-display-flex flex-wrap-wrap"
  }, [_c('div', {
    staticClass: "col-lg-12 col-xs-12"
  }, [_c('h4', {
    staticClass: "ls-title-4 ls-sm-margin-bottom ls-no-padding"
  }, [_vm._v(_vm._s(_vm.$t('invoices.show.invoice_data')))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-2 col-lg-4"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.identifier')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.invoice.identifier))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-2 col-lg-4"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.code')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.invoice.code))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-2 col-lg-4"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.contract')))]), _vm._v(" "), (_vm.invoice.contract_id) ? _c('router-link', {
    staticClass: "link",
    attrs: {
      "title": "",
      "to": {
        name: 'contract_details',
        params: {
          id: _vm.invoice.contract_id
        }
      }
    },
    slot: "button"
  }, [_vm._v(_vm._s(_vm.invoice.contract_id))]) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-2 col-lg-4"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.amount_due')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "plan.description"
    }
  }, [_vm._v(_vm._s(_vm.money.parseViewValue(_vm.invoice.amount_due)))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-2 col-lg-4"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.status')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('invoices.attributes.statuses.' + _vm.invoice.status)))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-2 col-lg-4"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.created_at')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "plan.description"
    }
  }, [_vm._v(_vm._s(_vm.date.parseDate(_vm.invoice.created_at)))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-2 col-lg-4"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.due_date')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "plan.description"
    }
  }, [_vm._v(_vm._s(_vm.date.parseDate(_vm.invoice.due_date)))])]), _vm._v(" "), (_vm.invoice.paid_at) ? _c('label', {
    staticClass: "ls-label col-xlg-3 col-lg-4"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.paid_at')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.date.parseDate(_vm.invoice.paid_at)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 ls-sm-space ls-no-padding-top invoice-box"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12 col-xlg-12 ls-float-left ls-no-padding"
  }, [_c('h4', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('invoices.show.invoice_items')))])]), _vm._v(" "), (_vm.invoice.invoice_items.length) ? _c('table', {
    staticClass: "ls-table ls-float-left ls-sm-space"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('invoices.details.description')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('invoices.details.period')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('invoices.details.label')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('invoices.details.value')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activesInvoiceItems(_vm.invoice)), function(invoice_item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(invoice_item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.periodicity(invoice_item)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice_item.resource_label))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(invoice_item.price)))])])
  }))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12 ls-display-flex flex-wrap-wrap align-itens-strech align-content-space-between"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12 ls-no-padding"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space"
  }, [_c('h4', {
    staticClass: "ls-title-4 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('invoices.labels.customer_data')))]), _vm._v(" "), (Object.keys(_vm.customer).length) ? _c('div', [_c('label', {
    staticClass: "ls-label col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.name')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "plan.description"
    }
  }, [_vm._v(_vm._s(_vm.customer.name || '-'))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.mail')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "plan.description"
    }
  }, [_vm._v(_vm._s(_vm.customer.email || '-'))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.cpf')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "plan.description"
    }
  }, [_vm._v(_vm._s(_vm.customer.cpf || '-'))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.show.cnpj')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "plan.description"
    }
  }, [_vm._v(_vm._s(_vm.customer.cnpj || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xlg-12"
  }, [_c('p', [_c('router-link', {
    staticClass: "ls-float-right link",
    attrs: {
      "to": {
        name: 'customers_details',
        params: {
          id: _vm.customer.id
        }
      },
      "title": "Início",
      "role": "menuitem"
    }
  }, [_vm._v(_vm._s(_vm.$t('customers.show.details'))), _c('span', {
    staticClass: "ls-ico-shaft-right ls-xs-margin-left"
  })])], 1)])]) : _c('div', [_c('h4', {
    staticClass: "ls-title-5 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('invoices.alerts.no_data')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12 ls-no-padding ls-md-margin-top"
  }, [_c('authorized-link', {
    staticClass: "align-itens-strech",
    attrs: {
      "tag": "show_invoice_orders"
    }
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space lg-md-margin-bottom-in-sm"
  }, [_c('h4', {
    staticClass: "ls-title-4 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('invoices.labels.orders')))]), _vm._v(" "), (_vm.orders.length) ? _c('p', [_c('a', {
    staticClass: "link",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Início",
      "role": "menuitem"
    },
    on: {
      "click": function($event) {
        _vm.showOrdersModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.labels.show_orders')))])]) : _c('h4', {
    staticClass: "ls-title-5 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('invoices.labels.no_orders')))])])])], 1)])])]), _vm._v(" "), _c('modal-send-payment', {
    model: {
      value: (_vm.resendPaymentObjects),
      callback: function($$v) {
        _vm.resendPaymentObjects = $$v
      },
      expression: "resendPaymentObjects"
    }
  }), _vm._v(" "), _c('modal-cancelation', {
    model: {
      value: (_vm.modalCancelation),
      callback: function($$v) {
        _vm.modalCancelation = $$v
      },
      expression: "modalCancelation"
    }
  }), _vm._v(" "), _c('modal-reverse', {
    model: {
      value: (_vm.modalReverse),
      callback: function($$v) {
        _vm.modalReverse = $$v
      },
      expression: "modalReverse"
    }
  }), _vm._v(" "), _c('modal-manual-confirmation', {
    model: {
      value: (_vm.manualConfirmationModal),
      callback: function($$v) {
        _vm.manualConfirmationModal = $$v
      },
      expression: "manualConfirmationModal"
    }
  }), _vm._v(" "), _c('modal-change-corp-due-date', {
    model: {
      value: (_vm.modalChangeCorpDueDate),
      callback: function($$v) {
        _vm.modalChangeCorpDueDate = $$v
      },
      expression: "modalChangeCorpDueDate"
    }
  }), _vm._v(" "), _c('modal-cancel-tax-invoice', {
    model: {
      value: (_vm.modalCancelTaxInvoice),
      callback: function($$v) {
        _vm.modalCancelTaxInvoice = $$v
      },
      expression: "modalCancelTaxInvoice"
    }
  }), _vm._v(" "), _c('modal-orders', {
    model: {
      value: (_vm.ordersModal),
      callback: function($$v) {
        _vm.ordersModal = $$v
      },
      expression: "ordersModal"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0edc878"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/invoices/Show.vue
// module id = 819
// module chunks = 1